import React, { CSSProperties, Fragment } from 'react';
import classNames from 'classnames';
import s from '#components/controls/buttons/buttonCube/buttonCube.module.scss';

type Props = {
  dataTestId?: string;
  href?: string;
  text?: string;
  icon?: string;
  extraClass?: string;
  isSizeSmall?: boolean;
  onClick: (event: React.MouseEvent) => void;
  style?: CSSProperties;
};

const ButtonCube = ({
  dataTestId,
  href,
  text,
  icon,
  extraClass,
  isSizeSmall,
  onClick,
  style,
}: Props) => {
  const blockClass = classNames(s.host, extraClass, {
    [s.isShare]: icon === 'share',
    [s.isAdd]: !icon || icon === 'cross',
    [s.isClipboard]: icon === 'clipboard',
    [s.isCheck]: icon === 'check',
    [s.isX]: icon === 'x',
    [s.isSizeSmall]: !!isSizeSmall,
  });

  return (
    <Fragment>
      {href ? (
        <a
          data-testid={dataTestId}
          href={href}
          className={blockClass}
          title={text}
          style={style}
        >
          <span className={s.inner}>{text}</span>
        </a>
      ) : (
        <button
          className={blockClass}
          data-testid={dataTestId}
          type="button"
          title={text}
          onClick={onClick}
          style={style}
        >
          <span className={s.inner}>{text}</span>
        </button>
      )}
    </Fragment>
  );
};

export default ButtonCube;
